module.exports = __webpack_public_path__ + "media/GLAMPING_7.17a3deda.mp4";